import tippy from 'tippy.js';

window.addEventListener('DOMContentLoaded', (event) => {
    const items = document.querySelectorAll('.js-cluster-popover');

    items.forEach((el) => {
        let trigger = el.querySelector('.cluster-member-icon')
        let popover = el.querySelector('.cluster-member-popover')

        tippy(trigger, {
            content: popover.innerHTML,
            allowHTML: true,
            duration: 0,
            placement: 'auto-start'
        });
    })
});

